
import { CheckCircle, AlertCircle } from 'lucide-react';

type VerificationStatusType = 'loading' | 'success' | 'error';

interface VerificationStatusProps {
  status: VerificationStatusType;
  isNative: boolean;
  showOpenAppButton?: boolean;
  onOpenApp?: () => void;
}

export const VerificationStatus = ({ status, isNative, showOpenAppButton, onOpenApp }: VerificationStatusProps) => {
  switch (status) {
    case 'loading':
      return (
        <div className="text-center space-y-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto"></div>
          <p>Verifying your email and logging you in...</p>
        </div>
      );
    case 'success':
      return (
        <>
          <div className="flex justify-center">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Welcome to MindNote!</h1>
          <p className="text-gray-600">
            Your email has been verified and you're now logged in.
            {showOpenAppButton
              ? ' Tap the button below to return to the app.'
              : " You'll be redirected to your dashboard in a moment."}
          </p>
          {showOpenAppButton && onOpenApp && (
            <button
              onClick={onOpenApp}
              className="mt-4 w-full py-3 px-6 rounded-lg bg-primary text-primary-foreground font-semibold text-lg shadow-md active:scale-95 transition-transform"
            >
              Open in MindNote
            </button>
          )}
        </>
      );
    case 'error':
      return (
        <>
          <div className="flex justify-center">
            <AlertCircle className="h-16 w-16 text-red-500" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Verification Failed</h1>
          <p className="text-gray-600">
            There was an issue verifying your email. Please try again or contact support.
          </p>
        </>
      );
  }
};
